import { useCallback } from "react";

import { chatToolCallsVar } from "@apps/ask-ai/ask-ai-context";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherChatToolCall({
  channelName,
}: {
  channelName: string;
}) {
  const handleChatToolCall = useCallback(
    ({
      chat_session_id,
      call_id,
      tool_name,
      result_count,
      description,
      status,
    }: {
      chat_session_id: number;
      call_id: string;
      tool_name: string;
      result_count?: number;
      description?: string;
      status?: "started" | "completed" | "failed";
    }) => {
      const existing = chatToolCallsVar();
      const idx = existing.findIndex((tc) => tc.callId === call_id);
      const next = {
        chatSessionId: chat_session_id,
        callId: call_id,
        toolName: tool_name,
        resultCount: result_count,
        description,
        status,
      };
      if (idx >= 0) {
        const updated = [...existing];
        updated[idx] = next;
        chatToolCallsVar(updated);
      } else {
        chatToolCallsVar([...existing, next]);
      }
    },
    [],
  );
  usePusher(channelName, "chat_tool_call", handleChatToolCall);
  return null;
}
